import { render, staticRenderFns } from "./TopTenItemCard.vue?vue&type=template&id=0013f66a&scoped=true&"
import script from "./TopTenItemCard.vue?vue&type=script&lang=js&"
export * from "./TopTenItemCard.vue?vue&type=script&lang=js&"
import style0 from "./TopTenItemCard.vue?vue&type=style&index=0&id=0013f66a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013f66a",
  null
  
)

export default component.exports